<template>
    <div class="one_content">
        <div class="inp">
            <div class="title">手机号码</div>
            <input placeholder="请输入11位有效手机号码" maxlength="11" :readonly="condition == 2" v-model="localIphone"
                @input="emitChange" />
        </div>
        <div class="inp inpno">
            <div class="title">ICCID卡号</div>
            <input placeholder="请输入ICCID卡号 后七位" maxlength="7" :readonly="condition == 2" v-model="localWholetcard"
                @input="emitChange" />
        </div>
        <div class="inp inpno">
            <div class="title">联系方式</div>
            <input placeholder="请输入联系方式（选填）" maxlength="11" v-model="localSparePhone" @keyup="onlyNumber"
                @input="emitChange" />
        </div>
    </div>
</template>

<script>
export default {
    name: "OpenCardForm",
    props: {
        condition: Number,
        Iphone: String,
        wholetcard: String,
        sparePhone: String,
        active: {
            type: [Number, String],
        },
    },
    data() {
        return {
            localIphone: this.Iphone,
            localWholetcard: this.wholetcard,
            localSparePhone: this.sparePhone,
            localActive: this.active,
        }
    },
    watch: {
        Iphone(val) {
            this.localIphone = val;
        },
        wholetcard(val) {
            this.localWholetcard = val;
        },
        active(val) {
            this.localActive = val;
        },
    },
    methods: {
        emitChange() {
            this.$emit("form-change", {
                Iphone: this.localIphone,
                wholetcard: this.localWholetcard,
                sparePhone: this.localSparePhone
            })
        },
        onlyNumber(e) {
            e.target.value = e.target.value.replace(/[^\d.]/g, "")
            this.localSparePhone = e.target.value
            this.emitChange()
        },
        isMobile(val) {
            // 简单手机号正则（以1开头，11位数字）
            return /^1[3-9]\d{9}$/.test(val)
        },
        validateForm() {
            if (this.Iphone === "" && this.wholetcard === "") {
                return { valid: false, message: "手机号或卡号不能为空" }
            } else if (!this.isMobile(this.Iphone)) {
                return { valid: false, message: "请输入正确的手机号码" }
            } else if (this.wholetcard.length !== 7) {
                return { valid: false, message: "卡号长度有误，请重新输入" }
            } else if (this.sparePhone && !this.isMobile(this.sparePhone)) {
                return { valid: false, message: "请输入正确的联系方式" }
            }
            return { valid: true }
        }
    }
}
</script>
<style lang="scss" scoped>
.one_content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    margin-top: px2rem(20);
    padding: px2rem(0) px2rem(20);

    .inp {
        width: 80%;
        height: px2rem(80);
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: px2rem(34);
        margin-top: px2rem(40);
        color: #6d6d6f;
        border-bottom: px2rem(1) solid #f0f0f2;

        input {
            width: 70%;
            font-size: px2rem(32);
        }

        input::-webkit-input-placeholder {
            color: #aab2bd;
            font-size: px2rem(26);
        }
    }

    .inpno {
        border: none;
        margin-bottom: px2rem(8);
    }
}
</style>
